module.exports = __webpack_public_path__ + "static/media/npmmCollection.0a21aef1.PNG";